import { Box } from "@chakra-ui/react";
import React from "react";
import SubTopic from "../components/SubTopic";
const SubTopicScreen = () => {
  return (
    <Box>
      <SubTopic />
    </Box>
  );
};

export default SubTopicScreen;
